import { CardBasic } from "@/components/ui-library-new/card/CardBasic"
import { BlokProps } from "@/helpers/StoryblokHelpers"
import { cn, findColorName } from "@/utils/utils"
import { CardSectionStoryblok } from "@storyblok-types"
import { SbBlokData, StoryblokServerComponent, storyblokEditable } from "@storyblok/react/rsc"

type CardVariant = "default" | "soft" | "softElevated"

const CARD_VARIANTS: CardVariant[] = ["default", "soft", "softElevated"]

export const CardSection = ({ blok }: BlokProps<CardSectionStoryblok>) => {
  const { heading, cards, variant, background } = blok

  const items = (cards ?? []) as SbBlokData[]

  if (items.length === 0) return null

  const cardVariant = CARD_VARIANTS.includes(variant as CardVariant) ? (variant as CardVariant) : undefined

  const bg = findColorName(background as string | undefined)

  return (
    <section
      {...storyblokEditable(blok as SbBlokData)}
      className={cn("py-[18px] lg:py-10", bg === "surface" && "bg-surface")}
    >
      <div className="mx-auto w-full max-w-[1155px] scroll-mt-32 px-4 lg:px-8">
        {heading && <h2 className="mb-6 text-[18px] font-extrabold text-neutral-90 lg:text-2xl">{heading}</h2>}

        <div className={cn("grid grid-cols-1 gap-4 lg:gap-6", items.length > 1 && "lg:grid-cols-2")}>
          {items.map(nested => (
            <CardBasic
              key={nested._uid}
              variant={cardVariant}
              className="min-h-0 gap-2 p-4 leading-[14px] lg:p-[34px] [&_h2]:mb-3 [&_h2]:text-[16px] [&_h2]:font-semibold [&_h2]:leading-[22px] [&_h2]:tracking-[-0.045em] lg:[&_h2]:text-[20px] lg:[&_h2]:leading-[27px] [&_p]:mb-0 [&_p]:text-sm [&_p]:leading-5 [&_p]:tracking-normal [&_p]:text-neutral-50 lg:[&_p]:text-base lg:[&_p]:font-normal lg:[&_p]:leading-[23px]"
            >
              <StoryblokServerComponent blok={nested} />
            </CardBasic>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CardSection
